import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IUser } from 'src/app/core/models/user.model';

@Component({
  selector: 'app-general-settings-select',
  templateUrl: './general-settings-select.component.html',
  styleUrls: ['./general-settings-select.component.css']
})
export class GeneralSettingsSelectComponent implements OnInit {

  @Input() user: IUser;
  @Input() currentUser: IUser;
  @Input() defaultSelect:string;
  @Input() disabled: string;
  @Output() select = new EventEmitter<Object>();
  @Input() options: { value: string; description: string }[];
  @Input() processing: boolean;
  @Input() userSettings;
  @Input() hideArrow: boolean;

  

  constructor() { }

  ngOnInit(): void {
  }


  patchType(event) {
    this.select.emit(event);
  }

}
